// URL判定

// トップページかどうか判定
export const isTopPage = (path: string): boolean => {
  return path === '/';
};
// 体験一覧ページかどうか判定
export const isExperiencesPage = (path: string): boolean => {
  return path === '/experiences' || path === '/experiences/';
};
// 体験詳細ページかどうか判定
export const isExperienceSlugPage = (path: string): boolean => {
  return /experiences\/(?!.*\/).+/.test(path) || /experiences\/[^/]+?\/$/.test(path);
};

// path(URL)の末端にスラッシュがあった場合は削除、ない場合はそのまま返す
export const removeEndSlash = (path: string): string => {
  return path.replace(/(.*)\/$/, '$1');
};

/**
 * あるパス(targetPath)が、チェック対象のパスのリスト(pathList)に含まれるかどうか判定
 * @param targetPath : チェック対象のパス
 * @param pathList : チェックするパスのリスト
 */
const getIsPathMatched = (targetPath: string, pathList: string[]): boolean => {
  return pathList.some((path) => {
    const regex = new RegExp('^' + path.replace(/\*/g, '.*'));
    return regex.test(targetPath);
  });
};

const WABUNKA_UNAVAILABLE_PAGES_WHEN_MAINTENANCE_MODE = ['/experiences/*/reserve', '/experiences/*/done-reservation'];

// メンテナンス時にアクセス不可能なページかどうか判定
export const isUnavailableWhenMaintenanceMode = (path: string): boolean => {
  return getIsPathMatched(path, WABUNKA_UNAVAILABLE_PAGES_WHEN_MAINTENANCE_MODE);
};

export const isLeavingFromExperienceSlugPage = (path: string, slug: string) => {
  const pattern = new RegExp('.*/experiences/' + slug);
  return !pattern.test(path);
};
